import React from 'react';
import {Platform, StyleSheet, Text as NativeText} from 'react-native';
import styled, {css} from 'styled-components/native';

/**
 * DefaultText styled component that represents the base text component.
 */
const DefaultText = styled(NativeText)<{
  type?: 'bold' | 'semiBold';
  languageCode?: 'en' | 'ar';
}>`
  font-family: ${({theme, type, languageCode}) => {
    if (Platform.OS === 'web') {
      return theme.fonts[languageCode || 'en'].fontName;
    }
    if (type === 'bold') {
      return theme.fonts[languageCode || 'en'].bold;
    }
    if (type === 'semiBold') {
      return theme.fonts[languageCode || 'en'].semi_bold;
    }
    return theme.fonts[languageCode || 'en'].regular;
  }};
  ${({type}) =>
    Platform.OS === 'web' &&
    css`
      font-weight: ${type === 'bold' ? 700 : type === 'semiBold' ? 500 : 400};
      user-select: text !important;
      -webkit-user-select: text !important;
      -ms-user-select: text !important;
    `}
`;

/**
 * Text component that renders text with customizable style and font family.
 * @param {Object} props - Component props.
 * @param {Object} props.style - Custom style for the text.
 * @param {string} props.fontFamily - The font family to be used for the text.
 * @param {boolean} props.bold - Whether the text should be bold or not.
 * @returns {React.ReactElement} The Text component.
 */
const Text = (props: any): React.ReactElement => {
  const {bold, semiBold, children} = props;

  return (
    <DefaultText
      languageCode={'en'}
      type={bold ? 'bold' : semiBold ? 'semiBold' : 'regular'}
      {...props}
      style={[
        StyleSheet.flatten(props.style || {})?.fontSize &&
        Platform.OS === 'android'
          ? {
              lineHeight: StyleSheet.flatten(props.style || {}).fontSize * 1.3,
            }
          : {},
        props.style,
      ]}>
      {children}
    </DefaultText>
  );
};

export default Text;
